import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { mcpOrgCredentialsQueryKey } from "./useMcpOrgCredentials";

interface SetOrgCredentialParams {
  serverId: string;
  /** Name of an existing org secret that holds the token. */
  secretName: string;
}

/** Sets or replaces a server's org-wide token. */
export function useSetMcpOrgCredential(orgId: string | undefined) {
  const { mcpRegistryService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ serverId, secretName }: SetOrgCredentialParams) =>
      mcpRegistryService.setOrgCredential(serverId, orgId!, secretName),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: mcpOrgCredentialsQueryKey(orgId),
      });
    },
  });
}
